import { render, staticRenderFns } from "./Fright.vue?vue&type=template&id=04dbbcdf&scoped=true&"
import script from "./Fright.vue?vue&type=script&lang=js&"
export * from "./Fright.vue?vue&type=script&lang=js&"
import style0 from "./Fright.vue?vue&type=style&index=0&id=04dbbcdf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dbbcdf",
  null
  
)

export default component.exports